$("body").on("click", ".boton-copiar", function (e) {
    // const textoDiv=jQuery(this).closest('.statItems').find('.statResult').text();
    textoDiv = "";
    jQuery(this)
      .closest(".statItems")
      .find(".statResult li.read")
      .each(function () {
        textoDiv += $(this).text() + "\n"; // Agregar el texto del div y un salto de línea
      });
    console.log(textoDiv);
    boton = $(this);
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(textoDiv)
        .then(function () {
          console.log("Texto copiado al portapapeles.");
          agregarIconoBoton(boton);
          setTimeout(
            function (boton) {
              quitarIconoBoton(boton);
            },
            2000,
            boton
          );
        })
        .catch(function (error) {
          console.error("Error al copiar el texto: ", error);
        });
    } else {
      // Para navegadores antiguos que no admiten el Clipboard API
      const inputTemp = $("<textarea>");
      inputTemp.val(textoDiv);
      inputTemp.css({
        // Estilos para que el textarea sea oculto
        position: "absolute",
        left: "-9999px",
        top: (window.pageYOffset || document.documentElement.scrollTop) + "px",
      });
      $("body").append(inputTemp);
  
      inputTemp.select();
      document.execCommand("copy");
  
      inputTemp.remove();
      console.log("Texto copiado al portapapeles.");
  
      agregarIconoBoton(boton);
      setTimeout(
        function (boton) {
          quitarIconoBoton(boton);
        },
        2000,
        boton
      );
    }
  });